<svg [id]="'code-' + barcode"></svg>
